import { openDB } from 'idb';
import type { IDBPDatabase } from 'idb';
// github.com/jakearchibald/idb#opendb

// export const loadItemFromIndexedDB = (storeName, objectStore, id) =>
// let db: any;
export const createObjectStore = async (
	database: string,
	version: number,
	tableNamesArray: string[]
) => {
	try {
		// First, try to delete the existing database if it exists
		await deleteDB(database);

		// Then create a new database with the specified version
		return await openDB(database, version, {
			upgrade(store) {
				// console.info('DB open request UPGRADE NEEDED');
				for (const tableName of tableNamesArray) {
					if (store.objectStoreNames.contains(tableName)) {
						continue;
					}
					store.createObjectStore(tableName, {
						autoIncrement: true,
						keyPath: 'id'
					});
				}
				// db = store;
			},
			blocked() {
				console.warn('Database is blocked by another connection');
			},
			blocking() {
				console.warn('This connection is blocking another connection');
			},
			terminated() {
				console.warn('Database connection terminated');
			}
		});
	} catch (error) {
		console.error('Error creating object store:', error);
		return undefined;
	}
};

export const getValue = async (
	db: IDBPDatabase<unknown>,
	tableName: string,
	id: string
) => {
	const tx = db.transaction(tableName, 'readonly');
	const store = tx.objectStore(tableName);
	const result = await store.get(id);
	return result;
};

export const getAllValues = async (
	db: IDBPDatabase<unknown>,
	tableName: string
) => {
	const tx = db.transaction(tableName, 'readonly');
	const store = tx.objectStore(tableName);
	const result = await store.getAll();
	// console.log('Get All Data', JSON.stringify(result));
	return result;
};

export const putValue = async (
	db: IDBPDatabase<unknown>,
	tableName: string,
	value: any
) => {
	const tx = db.transaction(tableName, 'readwrite');
	const store = tx.objectStore(tableName);
	const result = await store.put(value);
	return result;
};

export const putBulkValues = async (
	db: IDBPDatabase<unknown>,
	tableName: string,
	values: any
) => {
	const tx = db.transaction(tableName, 'readwrite');
	const store = tx.objectStore(tableName);
	for (const value of values) {
		const _result = await store.put(value);
	}
	return await getAllValues(db, tableName);
};

export const deleteValue = async (
	db: IDBPDatabase<unknown>,
	tableName: string,
	id: string
) => {
	const tx = db.transaction(tableName, 'readwrite');
	const store = tx.objectStore(tableName);
	const result = await store.get(id);
	if (result === undefined || result === null) {
		return null;
	}
	await store.delete(id);
	return id;
};

export const deleteDB = async (database: string) => {
	return new Promise<void>((resolve, reject) => {
		const DBDeleteRequest = window.indexedDB.deleteDatabase(database);

		DBDeleteRequest.onerror = function (event) {
			console.error('Error deleting database:', event);
			reject(new Error('Failed to delete database'));
		};

		DBDeleteRequest.onblocked = function () {
			console.warn(
				'Database deletion blocked - waiting for connections to close'
			);
		};

		DBDeleteRequest.onsuccess = function () {
			// console.log('Database deleted successfully');
			resolve();
		};
	});
};

// ~ HOW TO USE IT
// const [book, setBook] = useState();
// const [books, setAllBooks] = useState();
// useEffect(() => {
// const runIndexDb = async () => {
// const indexedDb = new indexedDBHelper('test', 1);
// await indexedDBHelper.createObjectStore(['books', 'students']);
// await indexedDBHelper.putValue('books', { name: 'A Game of Thrones' });
// await indexedDBHelper.putBulkValue('books', [
// { name: 'A Song of Fire and Ice' },
// { name: 'Harry Potter and the Chamber of Secrets' },
// ]);
// await indexedDBHelper.getValue('books', 1);
// await indexedDBHelper.getAllValues('books');
// await indexedDBHelper.deleteValue('books', 1);
// setBook(await indexedDBHelperHelper.getValue('books', 1));
// setAllBooks(await indexedDBHelperHelper.getAllValues('books'));
// };
// runIndexDb();
// }, []);
